import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'dometic',
} as IModuleProps;
